import axios from '../../../config/axiosConfig';
import { ErrorResponse } from '../../../shared';
import { Admin, AdminStudent, AdminStudentsResponse } from '../../../shared/interfaces';

export const fetchAdminStudents = async(admin: Admin): Promise<AdminStudentsResponse|ErrorResponse> => {
  const body = {
    adminId: admin.administrationID,
    studentId: ''
  };
  const response = await axios.post<AdminStudent[]>('api/report/adminStudents', body)
    .then(res => res.data)
    .then((students): AdminStudentsResponse => ({
      __typename: 'AdminStudentsResponse',
      students
    }))
    .catch((errMsg: string):ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};

// export const printHandler = (): void => {
//   const printEl = document.getElementById('student-item-detail-section');
//   const printAnchor = document.getElementById('report-print-anchor');
//   if (printEl && printAnchor) {
//     printEl.style.visibility = 'hidden';
//     document.body.appendChild(printEl);
//     window.print(); // thread blocking
//     printEl.style.visibility = 'visible';
//     document.body.removeChild(printEl);
//     printAnchor.appendChild(printEl);
//     gaEvents.onGA4PrintStudentReport();
//   }
// };